import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('select2', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      return new ViewModel(params, element);
    },
  },
  template: html,
});
